// config/impuestos.js
/**
 * Alícuotas del IVA venezolano, para el formulario y los cálculos en pantalla.
 *
 * Los VALORES vienen de @factech/fiscal, compartido con el back: así una
 * alícuota que cambie se toca en un solo lugar. Las ETIQUETAS y las opciones
 * del selector se quedan acá, porque son decisiones de interfaz.
 */
import { ALICUOTAS_IVA, ALICUOTA_POR_DEFECTO, IGTF_PORCENTAJE, tasaDeItem } from '@factech/fiscal';

export { ALICUOTAS_IVA, ALICUOTA_POR_DEFECTO, IGTF_PORCENTAJE, tasaDeItem };

export const OPCIONES_FISCALES = [
  { valor: 'gravado:general', etiqueta: 'Gravado 16%', taxType: 'gravado', alicuota: 'general' },
  { valor: 'gravado:reducida', etiqueta: 'Gravado 8%', taxType: 'gravado', alicuota: 'reducida' },
  { valor: 'gravado:adicional', etiqueta: 'Gravado 31%', taxType: 'gravado', alicuota: 'adicional' },
  { valor: 'exento:general', etiqueta: 'Exento', taxType: 'exento', alicuota: 'general' },
  { valor: 'no_gravado:general', etiqueta: 'No gravado', taxType: 'no_gravado', alicuota: 'general' }
];

export const valorFiscalDeItem = (item) => {
  const taxType = item.taxType || (item.taxExempt ? 'exento' : 'gravado');
  const alicuota = ALICUOTAS_IVA[item.alicuota] ? item.alicuota : ALICUOTA_POR_DEFECTO;
  return `${taxType}:${taxType === 'gravado' ? alicuota : 'general'}`;
};
